import { List, ListSubheader, makeStyles } from "@material-ui/core";

import React from "react";
import TextItem from "./TextItem";
import { get } from "lodash";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  validLocation: {
    "& p": {
      color: theme.palette.success.main,
    },
  },
  invalidLocation: {
    "& p": {
      color: theme.palette.error.main,
    },
  },
}));
const Company = ({ record, source, maxWidth = 500 }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const companyTypeId = get(record, `${source}.company_type_id`);

  const certOffice = get(record, `${source}.certificate_local_office_count`);
  const certStatus = get(record, `${source}.certificate_status`);
  const certStatusInfo = get(record, `${source}.certificate_status_info`);
  const isValid = certStatus === "validated" && certOffice > 0;

  return (
    <List>
      <ListSubheader>
        {get(record, `${source}.company_type.name`)}
      </ListSubheader>
      <TextItem
        label={translate(`resources.companies.fields.name`)}
        value={get(record, `${source}.name`)}
        maxWidth={maxWidth}
      />
      {source === "partner" && (
        <TextItem
          label={translate(`resources.companies.fields.vat_code`)}
          value={get(record, `${source}.vat_code`)}
          maxWidth={maxWidth}
        />
      )}
      {source !== "partner" && (
        <TextItem
          label={translate(
            `resources.companies.fields.${companyTypeId}.operative_unit`
          )}
          value={get(record, `${source}.operative_unit`)}
          maxWidth={maxWidth}
        />
      )}
      <TextItem
        label={translate(
          `resources.companies.representative.${get(
            record,
            `${source}.representative`
          )}`
        )}
        value={`${get(record, `${source}.representative_name`)} ${get(
          record,
          `${source}.representative_surname`
        )}`}
        maxWidth={maxWidth}
      />
      {source === "partner" && (
        <TextItem
          label={translate(
            "resources.companies.fields.certificate_local_office"
          )}
          value={
            certStatus !== "validated"
              ? certStatusInfo ||
                translate(
                  "resources.companies.fields.certificate_local_office.pending"
                )
              : translate(
                  "resources.companies.fields.certificate_local_office.info",
                  get(record, source)
                )
          }
          className={isValid ? classes.validLocation : classes.invalidLocation}
          maxWidth={maxWidth}
        />
      )}
    </List>
  );
};

export default Company;
